<template>
  <div class="ResourceSharing">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="navList">
      <div
        :class="[componentTag.key == item.key ? 'cur' : '', 'navItem']"
        v-for="item in navList"
        :key="item.key"
        @click="OnCurNav(item)"
      >
        <router-link
          class="nuxtLink"
          :to="'/resourceSharing?key=' + item.key"
          :key="item.key"
        >
          {{ item.lable }}
        </router-link>
      </div>
    </div>
    <component :is="componentTag.key" :key="componentTag.key"></component>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner";

import PoliciesRegulations from "@/components/ResourceSharing/PoliciesRegulations";
import GroupStandards from "@/components/ResourceSharing/GroupStandards";
import MembershipQualifications from "@/components/ResourceSharing/MembershipQualifications";
export default {
  name: "News",
  components: {
    PageBanner,
    PoliciesRegulations,
    GroupStandards,
    MembershipQualifications,
  },
  metaInfo() {
    return {
      title: "资源共享",
      meta: [
        {
          name: "keywords",
          content: "广州化工行业协会,专业技术人才,职业技能人才",
        },
        {
          name: "description",
          content:
            "广州市化工行业协会成立于1999年4月，是由广州地区从事化学工业和化工相关产业的生产、经营、储存、设计、服务咨询等企业或事业单位自愿结成的地方性、非营利性的社会组织。",
        },
      ],
    };
  },
  data() {
    return {
      componentTag: {
        lable: "政策法规     ",
        key: "PoliciesRegulations",
      },
      navList: [
        {
          lable: "政策法规",
          key: "PoliciesRegulations",
        },
        {
          lable: "团体标准查询",
          key: "GroupStandards",
        },
        {
          lable: "会员资质",
          key: "MembershipQualifications",
        },
      ],

      bannerObj: {
        lableZh: "资源共享",
        lableEn: "ResourceSharing",
        bannerImg: require("../../assets/img/vocational_banner.png"),
      },
    };
  },
  created() {
    // this.getInfoManageList();
  },
  mounted() {},
  methods: {
    OnCurNav(data) {
      // console.log(data);
      this.componentTag = data;
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal, oldval) {
        if (newVal != oldval && newVal.query.key) {
          let resList = this.navList.filter((item) => {
            // console.log(newVal.query.key);
            // console.log(item.key);
            return newVal.query.key === item.key;
          });
          this.componentTag = resList[0];
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.textslh {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.ResourceSharing {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  .banner {
    width: 100%;
  }
  .navList {
    display: flex;
    justify-content: space-between;
    width: $themeMinWidth;
    box-sizing: border-box;
    padding: 0 90px;
    position: relative;
    z-index: 66;
    margin: -200px auto 0;
    .navItem {
      &.cur a,
      &:hover a {
        background-color: #003b99;
        color: #ffffff;
      }
      a {
        display: block;
        width: 222px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background-color: #ffffff;
        color: #333333;
        border: solid 1px #ffffff;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
}
.Company {
  padding: 0 0 60px 0;
  position: relative;
}
</style>
